export default "__VITE_ASSET__e39a8f25__"